import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { catchError, from, map, of, switchMap } from "rxjs";
import { SessionService } from "src/app/services/session.service";
import { AppInitialDataService } from "src/app/shared/services/app-initial-data.service";

/** Ops Console bootstrap: `/user/me` + app config only (no billing customer). */
export const loadOpsInitialDataGuard: CanActivateFn = () => {
  const appInitialDataService = inject(AppInitialDataService);
  const sessionService = inject(SessionService);

  // Angular runs all canActivate guards for a route concurrently, not in
  // array order, so AuthGuard resolving `false` does not stop this guard
  // from firing. Check the session here too, and skip the bootstrap calls
  // when it's missing — AuthGuard already owns the redirect/dialog/signOut
  // for that case.
  return from(sessionService.isUserLoggedIn()).pipe(
    switchMap((isSignedIn) => {
      if (!isSignedIn) {
        return of(false);
      }

      return appInitialDataService.ensureOpsInitialDataLoaded().pipe(
        map(() => true),
        catchError(() => {
          sessionService.signOutUser();
          return of(false);
        }),
      );
    }),
  );
};
